import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useAuth } from "../../context/AuthContext";

export default function Topbar() {
    const { user, logout } = useAuth();

    return (
        <Box

            sx={{
                ml: 32,
                height: 70,
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 3,
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Painel Admin
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography>Olá, {user.firstName} {user.lastName} </Typography>

                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                        logout();
                        window.location.href = "/auth";
                    }}
                >
                    Sair
                </Button>
            </Box>
        </Box>
    );
}
